import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DatabaseUserGroup } from 'src/modules/database/shared/database-user-group.model';
import { Objects } from 'src/modules/utils/shared/objects';
import { EntityDefinition } from '../../models/entity-definition.model';
import { TableData } from '../../models/table-data.model';
import { TableRow } from '../../models/table-row.model';
import { TableCellType } from '../../netgen/TableCellType';
import { TableColumn } from '../../netgen/TableColumn';
import { AdminBaseListComponent } from '../admin-base-list/admin-base-list.component';

@Component({
    selector: 'app-edit-general-user-groups',
    templateUrl: '../../../sm-base/components/admin-base-list/admin-base-list.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class EditGeneralUserGroupsComponent extends AdminBaseListComponent<DatabaseUserGroup> {
 
    static staticDefinition = Objects.fromPlain(EntityDefinition<DatabaseUserGroup>, {
        type: DatabaseUserGroup,
        nameKey: "entity.DatabaseUserGroup.entityName",
        namePluralKey: "entity.DatabaseUserGroup.entityNamePlural",
        categoryKey: "entity.DatabaseUser.category",
        icon: "fas fa-users",
        apiEndpoint: "api/app/usergroup",
        adminListUrl: "/base2/admin/editGeneralUserGroups"
    });

    definition = EditGeneralUserGroupsComponent.staticDefinition;
  
    getTable(): TableData {
        return new TableData([
            new TableColumn("name", this.app.t("entity.DatabaseUserGroup.fields.name"), TableCellType.string, 30)
        ], this.listData.map(o => new TableRow("", o, {
            name: o.name
        })), ["name"]);
    }
}
